module.exports = __webpack_public_path__ + "img/packages-w.svg";